import { IdName } from './app';

export enum ConfigurationTriggerType {
  distance = 'distance',
  days = 'days',
}

export interface MaintenanceType {
  slug: string;
  value: string;
  _id: string;
}

export interface MaintenanceTypeRequest extends Omit<MaintenanceType, '_id' | 'client'> {}

export interface MaintenanceConfiguration extends IdName {
  description: string;
  triggerType: ConfigurationTriggerType;
  trigger: number;
  maintenanceType: MaintenanceType;
  client?: IdName;
}

export interface MaintenanceConfigurationRequest
  extends Omit<MaintenanceConfiguration, '_id' | 'client' | 'maintenanceType'> {
  maintenanceTypeId: string;
}

export interface EditMaintenanceConfigurationRequest extends Omit<MaintenanceConfigurationRequest, 'triggerType'> {}
